import {defineStore} from 'pinia';
import {ModuleLocalBudgetItem} from '@/stores/moduleConst';
import LocalBudgetItemAPI from '@/apis/di/localBudgetItemAPI';
import {BaseDictionaryStore} from '../baseDictionaryStore';
import i18nMonitor from '@/i18ns/vi/monitor/i18nMonitor';

const localBudgetItemStore = new BaseDictionaryStore(LocalBudgetItemAPI);

export const useLocalBudgetItemStore = defineStore(ModuleLocalBudgetItem, {
  state: () => ({
    ...localBudgetItemStore.state,
    _config: {
      key: 'local_budget_item_id',
      name: 'local_budget_item_name',
      table: 'di_local_budget_item',
      moduleName: i18nMonitor.ScreenName.DILocalBudgetItem,
      quickFollow: 'active',
      defaultSort: 'local_budget_item_name',
    },
    moduleName: 'diLocalBudgetItem',
  }),

  actions: {
    ...localBudgetItemStore.action,
  },
  getters: {
    ...localBudgetItemStore.getters,
  },
});
